import react, { useEffect, useState, useMemo, useContext } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _anim_ from "@Elementos/Animaciones";
import * as _btn_ from "@Elementos/Boton";
import * as _ipt_ from "@Elementos/Input";
import * as _chk_ from "@Elementos/CheckBox";
import * as _div_ from "@Elementos/Div";
import * as _opt_ from "@Elementos/Opciones";
import * as _txta_ from "@Elementos/TextArea";
import * as _f_ from "@Funciones/funciones";
import * as _ed_ from "@Funciones/estructurasDatos";
import * as _form_ from "@Elementos/Formulario";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import img_borrar from "@Iconos/borrar.png";
import img_editar from "@Iconos/editar.png";
import img_iconopdf from "@Iconos/iconopdf.png";
import img_xml from "@Iconos/xml.png";
import img_cdr from "@Iconos/cdr.png";
import img_agregar from "@Iconos/agregar.png";
import img_remate from "@Iconos/remate.png";
import img_bonificacion from "@Iconos/bonificacion.png";

import img_bien from "@Iconos/bien.png";
import img_almacen from "@Iconos/almacen.png";
import img_asistencia from "@Iconos/asistencia.png";
import img_despacho from "@Iconos/despacho.png";
import img_flechaOpciones from "@Iconos/flechaOpciones.png";
import img_generarPedido from "@Iconos/generarPedido.png";
import img_informacionGeneral from "@Iconos/informacionGeneral.png";
import img_menuOpciones from "@Iconos/menuOpciones.png";
import img_notificacion from "@Iconos/notificacion.png";
import img_pedidos from "@Iconos/pedidos.png";
import img_produccion from "@Iconos/produccion.png";
import img_stock from "@Iconos/stock.png";
import img_usuario from "@Iconos/usuario.png";
import img_ventaTienda from "@Iconos/ventaTienda.png";

import * as _testing_ from "@Funciones/testing";
import "@Estilos/Tabla.css";

export const Tabla = ({
  cabecera,
  registros,
  filtros,
  origenComponente = "TABLA",
  modoVista = "modo4",
  colorCabeceraCategoria = "var(--color_principal_1)",
  colorFuenteCabeceraCategoria = "white",
  altoDetalleInferior = "15rem",
  opcionesPorDefecto = 0b0,
  permiteOpciones = true,
  permiteActualizacionAlCerrarModal = false,
  permiteMultiseleccion = false,
  permiteDespliegueInferiorPorRegistro = false,
  permiteDespliegueModalPorRegistro = false,
  permiteVerCategoriaCompleta = false,
  camposCodigosSeleccion = [],
  reglasDeEstadoRegistros = {},
  datosComplementarios = {},
  mapaDeComponentes = {},
  campoCodigoCategoria = "categoria",
  campoCodigoRegistrosPorCategoria = "registros",
  campoOpcionesTablaInterna = "opcionesTablaInterna",
  campoCodigoDespliegaDetalleRegistro = "codCategoria",
  fObtenerSeleccionados,
  fObtenerCategoriasSeleccionadas,
  fNotificarActualizacionDeTabla,
  fObtenerDatosParcialesActualizados,
  fObtenerEstadoProcesando,
  zIndexTabla = 7,
  ...props
}) => {
  const { ecv_u, cv_u } = useContext(Contexto);
  const [elementos, eelementos] = useState({
    input: _ipt_.Input5,
    div: _div_.Div,
    boton: _btn_.Boton,
    textarea: _txta_.TextArea,
  });
  const [permisos, epermisos] = useState({});

  const [estadoRegistros, eestadoRegistros] = useState({
    deshabilitado: "Tabla-a-registro-deshabilitado",
    observado: "Tabla-a-registro-observado",
    aprobado: "Tabla-a-registro-aprobado",
    pendiente: "Tabla-a-registro-pendiente",
    rechazado: "Tabla-a-registro-rechazado",
    seleccionado: "Tabla-a-registro-seleccionado",
  });

  const [modosVisualizar, emodosVisualizar] = useState({
    modo1: {
      tabla_ancla_fd: "row",
      tabla_ancla_fw: "initial",
      tabla_ancla_gap: "1rem",
    },
    modo2: {
      tabla_ancla_fd: "row",
      tabla_ancla_fw: "wrap",
      tabla_ancla_gap: "1rem",
    },
    modo3: {
      tabla_ancla_fd: "column",
      tabla_ancla_fw: "wrap",
      tabla_ancla_gap: "1rem",
    },
    modo4: {
      tabla_ancla_fd: "column",
      tabla_ancla_fw: "initial",
      tabla_ancla_gap: "1rem",
    },
  });

  const [controles, econtroles] = useState({
    envio: 0b00000000000000000000000_100_000_000,
    bonificacion: 0b00000000000000000000000_010_000_000,
    remate: 0b00000000000000000000000_001_000_000,
    pdf: 0b00000000000000000000000_000_100_000,
    xml: 0b00000000000000000000000_000_010_000,
    cdr: 0b00000000000000000000000_000_001_000,
    visualizar: 0b00000000000000000000000_000_000_100,
    modificar: 0b00000000000000000000000_000_000_010,
    eliminar: 0b00000000000000000000000_000_000_001,
    filtro: 0b11111111111111111111111_111_111_111,
  });

  const [version, setVersion] = useState(0);

  const [v_u, ev_u] = useState({
    da_cabecera: null,
    da_categorias: null,
    do_filtros: null,
    eo_estilos: { anchos: "", anchosTitulo: "25% 50% 25%" },
    ec_oculto: "eg_oculto",
    ec_bolder: "eg_bolder",
    ec_expandir: "eg_expandir",
    do_seleccionados: {},
    do_categoriasSeleccionadas: {},
    do_desplegableSeleccionados: {},
    v_modal: false,
    do_registroEvento: null,
    d_registroEventoTipo: null,
    d_registroEventoComponente: null,
    do_registroEventoParametros: null,
    d_registroEventoEndpoint: null,
    d_registroEventoTimeout: null,
    d_registroEventoTitulo: null,
    d_columnaEvento: null,
    do_estilosModal: null,
    d_registroEventoComponenteInferior: null,
    procesandoApi: false,
    exitoFinalModal: false,
  });

  const [v_d, ev_d] = useState({});

  // const buscador = useMemo(() => {
  //   if (!registros || !cabecera) return null;
  //   const instancia = new _ed_.IndiceBusquedaRapida(registros, cabecera, "OPT");
  //   return instancia;
  // }, [registros, cabecera]);

  const buscador = useMemo(() => {
    if (!v_u.da_categorias || !cabecera) return null;

    const instancia = new _ed_.IndiceBusquedaRapida(
      v_u.da_categorias,
      cabecera,
      "OPT",
      campoCodigoRegistrosPorCategoria, // <--- Clave personalizada
    );

    return instancia;
  }, [v_u.da_categorias, v_u.da_cabecera]);

  const registrosFiltrados = useMemo(() => {
    setVersion((v) => 0);
    if (!buscador) return [];
    return buscador.filtrar(filtros);
  }, [buscador, filtros]);

  useEffect(() => {
    _f_.asignar(ev_u, { da_cabecera: cabecera });
    _f_.asignar(ev_u, { da_categorias: registros });
    _f_.asignar(ev_u, { do_filtros: filtros });

    if (cabecera) {
      console.log("registros", registros);
      console.log("cabecera", cabecera);

      let objetoDinamico = {};
      for (let regTemp of registros) {
        for (let opTemp of regTemp?.opcionesTablaInterna ?? []) {
          for (let eleTemp of opTemp) {
            // console.log(regTemp?.[eleTemp?.valor] );
            objetoDinamico[regTemp?.[campoCodigoCategoria] + "-" + (eleTemp?.variable ?? eleTemp?.valor)] =
              regTemp?.[eleTemp?.valor];
            // _f_.asignar(ev_d, { [regTemp?.[campoCodigoCategoria] + eleTemp?.variable]: regTemp?.[eleTemp?.valor] });
          }
        }
      }
      // console.log(objetoDinamico);
      ev_d(objetoDinamico);

      let anchoTotal = 0;
      const cantidadColumnas = cabecera.length;
      let anchoSeleccionCheckBox = "3rem";
      let anchosColumnasTemp = permiteMultiseleccion ? `${anchoSeleccionCheckBox} ` : "";
      if (permiteMultiseleccion) {
        anchoTotal += Number.parseInt(anchoSeleccionCheckBox);
      }
      for (let i = 0; i < cantidadColumnas; i++) {
        if (cabecera?.[i]?.visible) {
          anchosColumnasTemp += ` ${cabecera?.[i]?.estilos?.ancho ?? "11rem"}`;
          if (cabecera?.[i]?.estilos?.ancho) {
            anchoTotal += Number.parseInt(cabecera?.[i]?.estilos?.ancho);
          }
        }
        //else anchosColumnasTemp += ` 2rem`;
      }
      // console.log(anchoTotal)
      _f_.asignar(ev_u, {
        eo_estilos: {
          ..._f_.asignar(v_u.eo_estilos, { anchos: anchosColumnasTemp, anchoTotal: anchoTotal + "rem" }),
        },
      });
    }
    // setVersion((v) => v + 1);
  }, [registros, cabecera]);

  useEffect(() => {
    //console.log(v_u.do_seleccionados);
    fObtenerSeleccionados?.(v_u.do_seleccionados);
  }, [v_u.do_seleccionados]);

  useEffect(() => {
    //console.log(v_u.do_categoriasSeleccionadas);
    fObtenerCategoriasSeleccionadas?.(v_u.do_categoriasSeleccionadas);
  }, [v_u.do_categoriasSeleccionadas]);

  useEffect(() => {
    console.log("desplegableSeleccionado", v_u.do_desplegableSeleccionados);
  }, [v_u.do_desplegableSeleccionados]);

  function componentesOpciones({
    etiquetas,
    opciones,
    atributos,
    fRegistroOpcion,
    funcionEvento,
    relemento,
    celemento,
    rrelemento,
    modo,
  }) {
    let parametrosParaFuncionDinamica = {
      //...celemento?.funcionEvento?.parametros,
    };

    function fParametrosFuncion(evento, tipo) {
      //console.log(evento, tipo);
      for (let [parametroFuncion, campoRegistro] of Object.entries(funcionEvento?.[tipo]?.parametros)) {
        //console.log(parametroFuncion, campoRegistro);
        switch (campoRegistro.tipo) {
          case "constante":
            parametrosParaFuncionDinamica[parametroFuncion] = campoRegistro?.["clave"];
            break;
          case "evento":
            parametrosParaFuncionDinamica[parametroFuncion] = evento.target?.[campoRegistro?.clave];
            break;
          case "registro":
            parametrosParaFuncionDinamica[parametroFuncion] = rrelemento?.[campoRegistro?.clave];
            break;
          case "categoria":
            parametrosParaFuncionDinamica[parametroFuncion] = relemento?.[campoRegistro?.clave];
            break;
          case "complemento":
            parametrosParaFuncionDinamica[parametroFuncion] = datosComplementarios[campoRegistro?.clave];
            break;
        }
      }
    }
    function fMostrarModo(evento, tipo) {
      switch (funcionEvento?.[tipo]?.modo) {
        case "AGREGARCATEGORIA":
          let { registroEvento, titulo } = fRegistroOpcion([tipo, parametrosParaFuncionDinamica, "AGREGARCATEGORIA"]);
          console.log(cabecera);

          // 1. El registro clonado siempre es el mismo
          let registroClon = {
            ...registroEvento,
            Categoria: titulo,
            //Opciones: 0b11,
          };

          const categorias = [...v_u.da_categorias];

          // 2. Buscamos si la categoría ya existe en la lista
          let categoriaExistente = categorias.find((cat) => cat[campoCodigoCategoria] === titulo);

          if (categoriaExistente) {
            // Si existe: le metemos el registro clon a su lista de registros
            categoriaExistente[campoCodigoRegistrosPorCategoria] = [
              ...(categoriaExistente[campoCodigoRegistrosPorCategoria] || []),
              registroClon,
            ];
          } else {
            // Si no existe: creamos la categoría nueva con el registro clon dentro
            let nuevaCategoria = {
              ...categorias[0],
              [campoCodigoCategoria]: titulo,
              [campoOpcionesTablaInterna]: [],
              [campoCodigoRegistrosPorCategoria]: [registroClon],
            };

            categorias.push(nuevaCategoria);
          }

          // 3. Un solo asignar al final
          _f_.asignar(ev_u, { da_categorias: categorias });

          break;
        case "MODAL":
          fRegistroOpcion([tipo, parametrosParaFuncionDinamica, evento.type]);
          break;
        case "API":
          let llamadoDinamicoApi = _api_.f_llamarApiDinamica({
            parametros: parametrosParaFuncionDinamica,
            endpoint: funcionEvento?.[tipo]?.endpoint,
            timeout: funcionEvento?.[tipo]?.timeout,
          });
          llamadoDinamicoApi?.respuesta.then((dPC) => {
            //ecv_u(dPC);
            _f_.asignar(ecv_u, dPC, true, origenComponente);
            if (!dPC.error) {
              fNotificarActualizacionDeTabla?.(true);
              console.log(dPC.contenido);
            }
          });
          break;
      }
    }

    //console.log("ociones: 0b",opciones.toString(2));
    //console.log("funcionEvento:",funcionEvento)
    let modo1 = "COMPONENTE";
    let modo2 = "MODAL";
    if ((opciones & controles.envio) === controles.envio) {
      if (modo === modo1) {
        let envio = elementos["boton"];
        let atributosEnvio = {
          ...atributos,
          imagen: img_bien,
          [funcionEvento?.[controles.envio]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.envio);
            fMostrarModo(evento, controles.envio);
          },
        };
        etiquetas.push([envio, atributosEnvio]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{1F4DC} Bonificación" };
      }
    }
    if ((opciones & controles.bonificacion) === controles.bonificacion) {
      if (modo === modo1) {
        let bonificacion = elementos["boton"];
        let atributosBonificacion = {
          ...atributos,
          estilos: { ...atributos?.estilos, paddingB2: "0" },
          imagen: img_bonificacion,
          texto: "Bonificación",
          // estilos: {
          //   color: "var(--color_verde_1)",
          //   anchoB2: "6.5rem",
          // },
          [funcionEvento?.[controles.bonificacion]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.bonificacion);
            fMostrarModo(evento, controles.bonificacion);
          },
        };
        etiquetas.push([bonificacion, atributosBonificacion]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{1F4DC} Bonificación" };
      }
    }
    if ((opciones & controles.remate) === controles.remate) {
      if (modo === modo1) {
        // let remate = elementos["boton"];
        // let atributosRemate = {
        //   ...atributos,
        //   texto: "Remate",
        //   estilos: {
        //     color: "var(--color_rojo_1)",
        //   },
        //   [funcionEvento?.[controles.remate]?.tipo]: (evento) => {
        //     evento.stopPropagation();
        //     fParametrosFuncion(evento, controles.remate);
        //     fMostrarModo(evento, controles.remate);
        //   },
        // };
        // etiquetas.push([remate, atributosRemate]);

        /*
        estilos: {
          color: "var(--color_transparente)",
          anchoB2: "2.6rem",
          alto: "2.6rem",
        },
        */

        let remate = elementos["boton"];
        let atributosRemate = {
          ...atributos,
          estilos: { ...atributos?.estilos, paddingB2: "0" },
          imagen: img_remate,
          [funcionEvento?.[controles.remate]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.remate);
            fMostrarModo(evento, controles.remate);
          },
        };
        etiquetas.push([remate, atributosRemate]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{1F4DC} Remate" };
      }
    }
    if ((opciones & controles.pdf) === controles.pdf) {
      if (modo === modo1) {
        let pdf = elementos["boton"];
        let atributosPdf = {
          ...atributos,
          estilos: { ...atributos?.estilos, paddingB2: "0" },
          imagen: img_iconopdf,
          [funcionEvento?.[controles.pdf]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.pdf);
            fMostrarModo(evento, controles.pdf);
          },
        };
        etiquetas.push([pdf, atributosPdf]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{1F4DC} PDF" };
      }
    }
    if ((opciones & controles.xml) === controles.xml) {
      if (modo === modo1) {
        let xml = elementos["boton"];
        let atributosXML = {
          ...atributos,
          estilos: { ...atributos?.estilos, paddingB2: "0" },
          imagen: img_xml,
          [funcionEvento?.[controles.xml]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.xml);
            fMostrarModo(evento, controles.xml);
          },
        };
        etiquetas.push([xml, atributosXML]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{1F4D5} XML" };
      }
    }
    if ((opciones & controles.cdr) === controles.cdr) {
      if (modo === modo1) {
        let cdr = elementos["boton"];
        let atributosCdr = {
          ...atributos,
          estilos: { ...atributos?.estilos, paddingB2: "0" },
          imagen: img_cdr,
          [funcionEvento?.[controles.cdr]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.cdr);
            fMostrarModo(evento, controles.cdr);
          },
        };
        etiquetas.push([cdr, atributosCdr]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{1F50F} CDR" };
      }
    }
    if ((opciones & controles.modificar) === controles.modificar) {
      if (modo === modo1) {
        let editar = elementos["boton"];
        let atributosEditar = {
          ...atributos,
          imagen: img_editar,
          [funcionEvento?.[controles.modificar]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.modificar);
            fMostrarModo(evento, controles.modificar);
          },
        };
        etiquetas.push([editar, atributosEditar]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{2699} Editar" };
      }
    }
    if ((opciones & controles.eliminar) === controles.eliminar) {
      if (modo === modo1) {
        let eliminar = elementos["boton"];
        let atributosEliminar = {
          ...atributos,
          imagen: img_borrar,
          [funcionEvento?.[controles.eliminar]?.tipo]: (evento) => {
            evento.stopPropagation();
            fParametrosFuncion(evento, controles.eliminar);
            fMostrarModo(evento, controles.eliminar);
          },
        };
        etiquetas.push([eliminar, atributosEliminar]);
      }
      if (modo == modo2) {
        return { ...atributos, titulo: "\u{1F6A8} Eliminar" };
      }
    }
  }
  return (
    <div
      id={"Tabla-ancla"}
      ancla={modoVista}
      style={{
        ..._f_.estilosObjetoVariablesCSS(modosVisualizar?.[modoVista]),
        ["--zIndexTabla"]: zIndexTabla,
      }}>
      {v_u.v_modal &&
        Array.from({ length: 1 }).map((_, m) => {
          let funcionCerrar = () => {
            //console.log("click en funcion cerrar")
            // fNotificarActualizacionDeTabla?.(true);
            if (permiteActualizacionAlCerrarModal) {
              fNotificarActualizacionDeTabla?.(true);
            }
            _f_.asignar(ev_u, {
              v_modal: false,
              do_estilosModal: null,
              do_registroEvento: null,
              d_registroEventoTipo: null,
              do_registroEventoParametros: null,
              d_registroEventoEndpoint: null,
              d_registroEventoTimeout: null,
              d_registroEventoTitulo: null,
            });
            if (v_u.exitoFinalModal) {
              _f_.asignar(ev_u, { exitoFinalModal: false });
              fNotificarActualizacionDeTabla?.(true);
            }
          };
          let parametrosModal = {
            titulo: v_u.d_registroEventoTitulo,
            fCerrar: funcionCerrar,
            estilos: v_u.do_estilosModal ?? { anchoMI: "30rem" },
          };

          // console.log("origencomponente", origenComponente);
          // console.log("do_registroEvento:", v_u.do_registroEvento);
          // console.log("d_registroEventoTipo:", v_u.d_registroEventoTipo);
          // console.log(
          //   "d_registroEventoComponente:",
          //   v_u.d_registroEventoComponente,
          // );
          // console.log(
          //   "do_registroEventoParametros:",
          //   v_u.do_registroEventoParametros,
          // );
          // console.log(
          //   "d_registroEventoEndpoint:",
          //   v_u.d_registroEventoEndpoint,
          // );
          // console.log("d_registroEventoTimeout:", v_u.d_registroEventoTimeout);
          // console.log("d_registroEventoTitulo:", v_u.d_registroEventoTitulo);
          // console.log("d_columnaEvento:",v_u.d_columnaEvento)

          let Etiqueta = mapaDeComponentes?.[v_u?.d_registroEventoComponente];
          let parametrosEtiqueta = {
            origenComponente,
            registro: v_u.do_registroEvento,
            parametros: v_u.do_registroEventoParametros,
            tipoEvento: v_u.d_registroEventoTipo,
            columnaEvento: v_u.d_columnaEvento,
            fCerrarComponente: funcionCerrar,
            fEstablecerVariablesTabla: ev_u,
            fActualizarTablaTotal: fNotificarActualizacionDeTabla,
            datosComplementarios,
          };
          return (
            true && (
              <ModalInformacion key={m} {...parametrosModal}>
                {Array.from({ length: 1 }).map((_, l) => {
                  return (
                    <div style={{ width: "100%", height: "100%" }} key={l}>
                      {Etiqueta ? <Etiqueta {...parametrosEtiqueta} /> : "componente no asociado"}
                    </div>
                  );
                })}
              </ModalInformacion>
            )
          );
        })}
      {registrosFiltrados.map((relemento, i) => {
        return (
          <div
            style={_f_.estilosObjetoVariablesCSS({ ...relemento?.estilos, altoDetalleInferior })}
            className={"Tabla-a-categoria"}
            key={i}
            id={`Tabla-relemento-${i}`}>
            <div
              className={"Tabla-a-titulo-categoria"}
              style={{
                ..._f_.estilosObjetoVariablesCSS({
                  ...v_u.eo_estilos,
                  colorCabeceraCategoria,
                  colorFuenteCabeceraCategoria,
                }),
              }}>
              {permiteMultiseleccion ? (
                <div className="Tabla-titulo-seleccion">
                  <_chk_.CheckBox
                    texto="Seleccionar Todo"
                    checked={relemento?.[campoCodigoCategoria] in v_u.do_categoriasSeleccionadas}
                    onChange={(evento) => {
                      evento.stopPropagation();
                      if (evento.target.checked) {
                        let categoriaSeleccionadaTemp = {
                          [relemento?.[campoCodigoCategoria]]: relemento.registros,
                        };
                        _f_.asignar(ev_u, {
                          do_categoriasSeleccionadas: _f_.asignar(v_u.do_categoriasSeleccionadas, {
                            ...categoriaSeleccionadaTemp,
                          }),
                        });

                        let seleccionadosTemp = {};
                        for (let temp of registrosFiltrados[i].registros) {
                          seleccionadosTemp[
                            _f_.concatenarValoresConArreglo({
                              prefijo: relemento?.[campoCodigoCategoria] + "-",
                              arregloClaves: camposCodigosSeleccion,
                              objeto: temp,
                              union: "-",
                            })
                          ] = temp;
                        }
                        _f_.asignar(ev_u, {
                          do_seleccionados: _f_.asignar(v_u.do_seleccionados, {
                            ...seleccionadosTemp,
                          }),
                        });
                      } else {
                        let categoriaSeleccionadaTemp = v_u.do_categoriasSeleccionadas;
                        delete categoriaSeleccionadaTemp[relemento?.[campoCodigoCategoria]];

                        _f_.asignar(ev_u, {
                          do_categoriasSeleccionadas: _f_.asignar(v_u.do_categoriasSeleccionadas, {
                            ...categoriaSeleccionadaTemp,
                          }),
                        });

                        let seleccionadosTemp = v_u.do_seleccionados;

                        Object.keys(seleccionadosTemp)
                          .filter((clave) => clave.startsWith(relemento?.[campoCodigoCategoria]))
                          .forEach((clave) => delete seleccionadosTemp[clave]);

                        _f_.asignar(ev_u, {
                          do_seleccionados: _f_.asignar(v_u.do_seleccionados, {
                            ...seleccionadosTemp,
                          }),
                        });
                      }
                    }}
                  />
                </div>
              ) : (
                <div></div>
              )}
              <div className="Tabla-titulo-descripcion">{relemento?.[campoCodigoCategoria]}</div>
              <div className="Tabla-titulo-expandir">
                {permiteVerCategoriaCompleta && (
                  <_btn_.Boton
                    texto={`\u{25BC}`}
                    tipo="btn-2"
                    estilos={{
                      color: "var(--color_verde_1)",
                      anchoB2: "2rem",
                      fuente: "1.3rem",
                      altoB2: "2rem",
                    }}
                    procesando={false}
                    onClick={(evento) => {
                      const categoriaAExpandir = document.getElementById(`Tabla-relemento-${i}`);
                      categoriaAExpandir?.classList.toggle("eg_expandir");
                      evento.target.classList.toggle("girado");

                      // 2. Si se está expandiendo, hacemos auto-scroll hacia su inicio
                      const estaExpandido = categoriaAExpandir?.classList.contains("eg_expandir");

                      if (estaExpandido) {
                        // Pequeña espera para que el DOM procese la visibilidad
                        setTimeout(() => {
                          categoriaAExpandir?.scrollIntoView({
                            behavior: "smooth", // Desplazamiento suave
                            block: "start", // Alinea el inicio de la categoría arriba de la pantalla
                          });
                        }, 50);
                      }
                    }}
                  />
                )}
              </div>
            </div>
            <div className="Tabla-a-contenido">
              <div className={"Tabla-a-cuerpo"}>
                <div
                  className={"Tabla-a-registro Tabla-a-cabecera"}
                  style={_f_.estilosObjetoVariablesCSS(v_u.eo_estilos)}>
                  {permiteMultiseleccion && <span className="Tabla-a-c-elemento-seleccion"></span>}
                  {v_u.da_cabecera?.map((celemento, j) => {
                    let cabeceras = celemento?.separador
                      ? (celemento?.valor.split(celemento?.separador) ?? [])
                      : [celemento?.valor];

                    return (
                      <div
                        key={j}
                        className={`Tabla-a-c-elemento ${v_u.ec_bolder} + ${celemento.visible ? "" : v_u.ec_oculto}`}>
                        {cabeceras?.map((cab, idxcab) => {
                          return <div key={idxcab}>{cab}</div>;
                        })}
                      </div>
                    );
                  })}
                </div>
                {relemento?.[campoCodigoRegistrosPorCategoria]?.map((rrelemento, k) => {
                  let registroSeleccionadoClassName =
                    _f_.concatenarValoresConArreglo({
                      prefijo: relemento?.[campoCodigoCategoria] + "-",
                      arregloClaves: camposCodigosSeleccion,
                      union: "-",
                      objeto: rrelemento,
                    }) in v_u.do_seleccionados
                      ? "Tabla-a-registro-seleccionado"
                      : "";

                  let registroEstadoClassName = _f_.evaluarReglasDeEstados(reglasDeEstadoRegistros, rrelemento);
                  registroEstadoClassName = registroEstadoClassName
                    .filter((regla) => regla.resultado)
                    .map((regla) => estadoRegistros[regla["tipo"]])
                    .join(" ");

                  let punteroActivadoDetalleInferior =
                    permiteDespliegueInferiorPorRegistro || permiteDespliegueModalPorRegistro ? "punteroActivado" : "";

                  let registroClassName = `Tabla-a-registro ${punteroActivadoDetalleInferior} ${registroSeleccionadoClassName} ${registroEstadoClassName}`;
                  return (
                    <div
                      key={k}
                      className={`Tabla-a-contenedor-registro-desplegable ${
                        "Tabla-rrelemento-" +
                          _f_.concatenarValoresConArreglo({
                            prefijo: relemento?.[campoCodigoDespliegaDetalleRegistro] ?? "",
                            arregloClaves: camposCodigosSeleccion,
                            objeto: registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k],
                            union: "-",
                          }) in
                        v_u.do_desplegableSeleccionados
                          ? "expandido"
                          : ""
                      }`}>
                      <div
                        key={k}
                        className={registroClassName}
                        style={_f_.estilosObjetoVariablesCSS(v_u.eo_estilos)}
                        onClick={
                          permiteDespliegueInferiorPorRegistro
                            ? (evento) => {
                                const codigoDesplegableElemento =
                                  "Tabla-rrelemento-" +
                                  _f_.concatenarValoresConArreglo({
                                    prefijo: relemento?.[campoCodigoDespliegaDetalleRegistro] ?? "",
                                    arregloClaves: camposCodigosSeleccion,
                                    objeto: registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k],
                                    union: "-",
                                  });

                                if (codigoDesplegableElemento in v_u.do_desplegableSeleccionados) {
                                  let desplegableSeleccionadosTemp = {
                                    ...v_u.do_desplegableSeleccionados,
                                  };
                                  delete desplegableSeleccionadosTemp?.[codigoDesplegableElemento];
                                  _f_.asignar(ev_u, {
                                    do_desplegableSeleccionados: desplegableSeleccionadosTemp,
                                  });
                                } else {
                                  _f_.asignar(ev_u, {
                                    do_desplegableSeleccionados: _f_.asignar(v_u.do_desplegableSeleccionados, {
                                      [codigoDesplegableElemento]:
                                        registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k],
                                    }),
                                  });
                                }
                                console.log(registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k].funcionEvento);
                                _f_.asignar(ev_u, {
                                  // v_modal: true,
                                  // do_estilosModal:
                                  //   celemento?.funcionEvento?.estilos,
                                  do_registroEvento: registrosFiltrados[i].registros[k],
                                  // d_columnaEvento: celemento?.valor,
                                  d_registroEventoComponenteInferior:
                                    registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k]?.funcionEvento
                                      ?.componente,
                                  d_registroEventoTipo: evento.type,
                                  // do_registroEventoParametros:
                                  //   parametrosParaFuncionDinamica,
                                  // d_registroEventoEndpoint:
                                  //   celemento?.funcionEvento?.endpoint,
                                  // d_registroEventoTimeout:
                                  //   celemento?.funcionEvento?.timeout,
                                  // d_registroEventoTitulo:
                                  //   celemento?.funcionEvento?.titulo,
                                });
                              }
                            : permiteDespliegueModalPorRegistro
                              ? (evento) => {
                                  _f_.asignar(ev_u, {
                                    v_modal: true,
                                    do_estilosModal: rrelemento?.funcionEvento?.estilos,
                                    do_registroEvento: registrosFiltrados[i].registros[k],
                                    d_columnaEvento: rrelemento?.valor,
                                    d_registroEventoComponente: rrelemento?.funcionEvento?.componente,
                                    d_registroEventoTipo: evento.type,
                                    // do_registroEventoParametros: parametrosParaFuncionDinamica,
                                    d_registroEventoEndpoint: rrelemento?.funcionEvento?.endpoint,
                                    d_registroEventoTimeout: rrelemento?.funcionEvento?.timeout,
                                    d_registroEventoTitulo: rrelemento?.funcionEvento?.titulo,
                                  });
                                }
                              : undefined
                        }>
                        {permiteMultiseleccion && (
                          <span className="Tabla-a-c-elemento-seleccion">
                            <_chk_.CheckBox
                              texto=""
                              checked={
                                _f_.concatenarValoresConArreglo({
                                  prefijo: relemento?.[campoCodigoCategoria] + "-",
                                  arregloClaves: camposCodigosSeleccion,
                                  objeto: rrelemento,
                                  union: "-",
                                }) in v_u.do_seleccionados
                              }
                              onClick={(evento) => {
                                evento.stopPropagation();
                              }}
                              onChange={(evento) => {
                                evento.stopPropagation();
                                if (evento.target.checked) {
                                  _f_.asignar(ev_u, {
                                    do_seleccionados: _f_.asignar(v_u.do_seleccionados, {
                                      [_f_.concatenarValoresConArreglo({
                                        prefijo: relemento?.[campoCodigoCategoria] + "-",
                                        arregloClaves: camposCodigosSeleccion,
                                        objeto: rrelemento,
                                        union: "-",
                                      })]: registrosFiltrados[i].registros[k],
                                    }),
                                  });
                                } else {
                                  let seleccionadoTemp = v_u.do_seleccionados;
                                  delete seleccionadoTemp[
                                    _f_.concatenarValoresConArreglo({
                                      prefijo: relemento?.[campoCodigoCategoria] + "-",
                                      arregloClaves: camposCodigosSeleccion,
                                      objeto: rrelemento,
                                      union: "-",
                                    })
                                  ];
                                  _f_.asignar(ev_u, {
                                    do_seleccionados: _f_.asignar(v_u.do_seleccionados, { ...seleccionadoTemp }),
                                  });
                                }
                              }}
                            />
                          </span>
                        )}
                        {v_u.da_cabecera?.map((celemento, j) => {
                          let etiquetas = [];

                          if (celemento.tipo !== "control") {
                            //Etiqueta = elementos?.[celemento.tipo];
                            //INTERCEPTA LOS REGISTRO MARCADOS CON TIPOS PROPIOS DE REGISTRO Y FUNCIONALIDADES
                            let etiqueta = null;
                            if (rrelemento?.tiposCampos?.[celemento.valor]) {
                              celemento = { ...celemento, ...rrelemento.tiposCampos?.[celemento.valor] };
                              // console.log(rrelemento?.tiposCampos?.[celemento.valor])

                              etiqueta = elementos?.[celemento.tipo];
                            } else {
                              etiqueta = elementos?.[celemento.tipo];
                            }
                            //etiqueta = elementos?.[celemento.tipo]; //elementos["div"];
                            //console.log("entre elemento",rrelemento.codigo == v_u.)

                            if (v_u.do_registroEvento) {
                              // console.log(_f_.concatenarValoresConArreglo({
                              //         prefijo: relemento?.[campoCodigoCategoria] + "-",
                              //         arregloClaves: camposCodigosSeleccion,
                              //         objeto: v_u.do_registroEvento,
                              //         union: "-",
                              //       }))
                              // console.log(_f_.concatenarValoresConArreglo({
                              //         prefijo: relemento?.[campoCodigoCategoria] + "-",
                              //         arregloClaves: camposCodigosSeleccion,
                              //         objeto: rrelemento,
                              //         union: "-",
                              //       }))
                            }
                            let atributos = {
                              lang: "es",
                              disabled:
                                (celemento?.habilitado ?? true)
                                  ? _f_.concatenarValoresConArreglo({
                                      prefijo:
                                        (v_u.do_registroEvento?.[campoCodigoCategoria] ??
                                          v_u.do_registroEvento?.["Categoria"]) + "-",
                                      arregloClaves: camposCodigosSeleccion,
                                      objeto: v_u.do_registroEvento,
                                      union: "-",
                                    }) ==
                                      _f_.concatenarValoresConArreglo({
                                        prefijo: relemento?.[campoCodigoCategoria] + "-",
                                        arregloClaves: camposCodigosSeleccion,
                                        objeto: rrelemento,
                                        union: "-",
                                      }) && v_u.procesandoApi
                                    ? true
                                    : false
                                  : true,

                              ...(celemento.tipo != "input" && {
                                texto: _f_.formatearValor({
                                  valor: rrelemento[celemento?.valor],
                                  ...celemento?.formato,
                                }),
                              }),
                              //
                              inputkey:
                                _f_.concatenarValoresConArreglo({
                                  prefijo: relemento?.[campoCodigoCategoria] + "-",
                                  arregloClaves: camposCodigosSeleccion,
                                  objeto: v_u.do_registroEvento,
                                  union: "-",
                                }) ==
                                _f_.concatenarValoresConArreglo({
                                  prefijo: relemento?.[campoCodigoCategoria] + "-",
                                  arregloClaves: camposCodigosSeleccion,
                                  objeto: rrelemento,
                                  union: "-",
                                })
                                  ? Math.random()
                                  : version == 1
                                    ? "1"
                                    : Math.random(), //celemento.tipo != "input" ? Math.random() : version == 1 ? "1" : Math.random(),
                              autoComplete: "off",

                              tipo: celemento?.tipo == "input" ? (celemento?.dato ?? "text") : "btn-2",
                              // tipo: "btn-2",
                              estilos: { width: "100%", height: "2rem", ...celemento?.estilosElemento },
                              //REVISAR BUG 20102026
                              defaultValue: celemento?.dato == "number" ? (rrelemento[celemento?.valor] == 0 ? "":rrelemento[celemento?.valor]): rrelemento[celemento?.valor],
                              ...(celemento?.funcionEvento && {
                                onClick: (evento) => {
                                  evento.stopPropagation();
                                },
                              }),

                              ...(!celemento?.funcionEvento && {
                                onChange: (evento) => {
                                  evento.stopPropagation();
                                  let arregloValores = [];
                                  for (let temp of camposCodigosSeleccion) {
                                    arregloValores.push(registrosFiltrados[i].registros[k]?.[temp]);
                                  }
                                  if (buscador) {
                                    // Actualiza la referencia interna y re-indexa el Trie
                                    const exito = buscador.actualizarRegistro(
                                      campoCodigoCategoria, // Campo para identificar categoría
                                      registrosFiltrados[i]?.[campoCodigoCategoria], // Valor de categoría
                                      camposCodigosSeleccion, // Campo para identificar registro
                                      arregloValores, // Valor del registro
                                      [celemento.valor], //celemento.valor, // Campo a mutar
                                      [
                                        celemento?.dato == "number"
                                          ? Number.parseFloat(evento.target.value)
                                          : evento.target.value,
                                      ], //[evento.target.value], // Nuevo valor ingresado
                                    );
                                    if (exito) {
                                      // 3. Incrementamos la versión para forzar la actualización del useMemo
                                      //setVersion((v) => v + 1);
                                    }
                                  }
                                },
                              }),

                              ...(celemento?.funcionEvento?.tipo && {
                                [celemento?.funcionEvento?.tipo]: (evento) => {
                                  setVersion((v) => 1);
                                  evento.stopPropagation();
                                  //=================================
                                  //=================================
                                  // const copiaValorActual = {...registrosFiltrados[i].registros[k]}
                                  // console.log(copiaValorActual)
                                  let arregloValores = [];
                                  for (let temp of camposCodigosSeleccion) {
                                    arregloValores.push(registrosFiltrados[i].registros[k]?.[temp]);
                                  }
                                  if (buscador) {
                                    // Actualiza la referencia interna y re-indexa el Trie
                                    // console.log("elemento",registrosFiltrados[i]?.[campoCodigoCategoria])
                                    // console.log("valor:", evento.target.value);
                                    // console.log(
                                    //   "mutado:",
                                    //   _f_.formatearValor({
                                    //     valor: evento.target.value,
                                    //     ...celemento?.formato,
                                    //   }),
                                    // );
                                    //REVISAR
                                    if (celemento?.tipo != "boton") {
                                      const exito = buscador.actualizarRegistro(
                                        campoCodigoCategoria, // Campo para identificar categoría
                                        registrosFiltrados[i]?.[campoCodigoCategoria], // Valor de categoría
                                        camposCodigosSeleccion, // Campo para identificar registro
                                        arregloValores, // Valor del registro
                                        [celemento.valor], //celemento.valor, // Campo a mutar
                                        [
                                          celemento?.dato == "number"
                                            ? Number.parseFloat(evento.target.value)
                                            : evento.target.value,
                                        ], // Nuevo valor ingresado
                                      );
                                    }
                                  }
                                  //=================================
                                  //=================================

                                  //ADAPTAR PARAMETROS PARA LEER DEL REGISTRO
                                  let parametrosParaFuncionDinamica = {
                                    ...celemento?.funcionEvento?.parametros,
                                  };

                                  for (let [parametroFuncion, campoRegistro] of Object.entries(
                                    celemento?.funcionEvento?.parametros,
                                  )) {
                                    //console.log(parametroFuncion, campoRegistro);
                                    switch (campoRegistro.tipo) {
                                      case "constante":
                                        parametrosParaFuncionDinamica[parametroFuncion] = campoRegistro?.["clave"];
                                        break;
                                      case "evento":
                                        parametrosParaFuncionDinamica[parametroFuncion] =
                                          evento.target?.[campoRegistro?.clave];
                                        break;
                                      case "registro":
                                        parametrosParaFuncionDinamica[parametroFuncion] =
                                          rrelemento?.[campoRegistro?.clave];
                                        break;
                                      case "categoria":
                                        parametrosParaFuncionDinamica[parametroFuncion] =
                                          relemento?.[campoRegistro?.clave];
                                        break;
                                      case "complemento":
                                        parametrosParaFuncionDinamica[parametroFuncion] =
                                          datosComplementarios[campoRegistro?.clave];
                                        break;
                                    }
                                  }
                                  switch (celemento?.funcionEvento?.modo) {
                                    case "MODAL":
                                      _f_.asignar(ev_u, {
                                        v_modal: true,
                                        do_estilosModal: celemento?.funcionEvento?.estilos,
                                        do_registroEvento: registrosFiltrados[i].registros[k],
                                        d_columnaEvento: celemento?.valor,
                                        d_registroEventoComponente: celemento?.funcionEvento?.componente,
                                        d_registroEventoTipo: evento.type,
                                        do_registroEventoParametros: parametrosParaFuncionDinamica,
                                        d_registroEventoEndpoint: celemento?.funcionEvento?.endpoint,
                                        d_registroEventoTimeout: celemento?.funcionEvento?.timeout,
                                        d_registroEventoTitulo: celemento?.funcionEvento?.titulo,
                                      });
                                      break;
                                    case "API":
                                      console.log("evento",evento.target.value)
                                      console.log("registro",rrelemento)
                                      console.log("cabecera",celemento?.dato)
                                      // if (
                                      //   evento.target.value != ""
                                      // ) {
                                        //LA TABLA NOTIFICA AL COMPONENTE QUE LO LLAMA QUE SE ESTA LLAMANDO A LA API Y DEBE ESPERAR
                                        fObtenerEstadoProcesando?.(true);
                                        _f_.asignar(ev_u, {
                                          procesandoApi: true,
                                        });
                                        _f_.asignar(ev_u, {
                                          do_registroEvento: rrelemento,
                                        });
                                        let llamadoDinamicoApi = _api_.f_llamarApiDinamica({
                                          parametros: parametrosParaFuncionDinamica,
                                          endpoint: celemento?.funcionEvento?.endpoint,
                                          timeout: celemento?.funcionEvento?.timeout,
                                        });
                                        llamadoDinamicoApi?.respuesta.then((dPC) => {
                                          //ecv_u(dPC);
                                          _f_.asignar(ecv_u, dPC, true, origenComponente);
                                          console.log(dPC);
                                          // if (!dPC.error) {
                                            switch (celemento?.funcionEvento?.actualizacion) {
                                              case "PARCIAL":
                                                let camposMutarApi = [];
                                                let valoresMutarApi = [];
                                                for (let [campoRegistro, campoApi] of Object.entries(
                                                  celemento?.funcionEvento?.camposActualizaTabla,
                                                )) {
                                                  camposMutarApi.push(campoRegistro);
                                                  let objetoNivelDato = dPC.contenido,
                                                    dato = null;
                                                  campoApi.split(".").map((claveNivel, i) => {
                                                    objetoNivelDato = objetoNivelDato?.[claveNivel];
                                                  });
                                                  valoresMutarApi.push(objetoNivelDato);
                                                }

                                                //inicio valores dinámicos para todo la tabla
                                                if ("campoActualizaOpciones" in celemento?.funcionEvento) {
                                                  let valoresDinamicosApi = [];
                                                  for (let [campoRegistro, campoApi] of Object.entries(
                                                    celemento?.funcionEvento?.campoActualizaOpciones,
                                                  )) {
                                                    camposMutarApi.push(campoRegistro);
                                                    let objetoNivelDato = dPC.contenido,
                                                      dato = null;
                                                    campoApi.split(".").map((claveNivel, i) => {
                                                      objetoNivelDato = objetoNivelDato?.[claveNivel];
                                                    });
                                                    valoresDinamicosApi.push(objetoNivelDato);
                                                    console.log(objetoNivelDato);
                                                    _f_.asignar(ev_d, {
                                                      [relemento?.[campoCodigoCategoria] + "-" + campoRegistro]:
                                                        objetoNivelDato,
                                                    });
                                                  }
                                                }

                                                //fin valores dinámicos para todo la tabla

                                                let arregloValores = [];
                                                for (let temp of camposCodigosSeleccion) {
                                                  arregloValores.push(registrosFiltrados[i].registros[k]?.[temp]);
                                                }
                                                if (buscador) {
                                                  // Actualiza la referencia interna y re-indexa el Trie
                                                  const exito = buscador.actualizarRegistro(
                                                    campoCodigoCategoria, // Campo para identificar categoría
                                                    registrosFiltrados[i]?.[campoCodigoCategoria], // Valor de categoría
                                                    camposCodigosSeleccion, // Campo para identificar registro
                                                    arregloValores, // Valor del registro
                                                    camposMutarApi, //celemento.valor, // Campo a mutar
                                                    valoresMutarApi, // Nuevo valor ingresado
                                                  );
                                                  if (exito) {
                                                    // console.log(
                                                    //   "camposEmpaquetaResultado:",
                                                    //   celemento?.camposEmpaquetaResultado,
                                                    // );
                                                    let datosEmpaquetados = {};
                                                    console.log("antes del error faltal");

                                                    if (celemento?.funcionEvento?.camposEmpaquetaResultado) {
                                                      for (let [campoSalida, campoApi] of Object.entries(
                                                        celemento?.funcionEvento?.camposEmpaquetaResultado,
                                                      )) {
                                                        let objetoNivelDato = dPC.contenido;
                                                        campoApi.split(".").map((claveNivel, i) => {
                                                          objetoNivelDato = objetoNivelDato?.[claveNivel];
                                                        });
                                                        datosEmpaquetados[campoSalida] = objetoNivelDato;
                                                      }
                                                      fObtenerDatosParcialesActualizados?.(datosEmpaquetados);

                                                      // 3. Incrementamos la versión para forzar la actualización del useMemo
                                                      //setVersion((v) => v + 1);
                                                    }
                                                  }
                                                }

                                                break;
                                              case "TOTAL":
                                                fNotificarActualizacionDeTabla?.(true);
                                                break;
                                              default:
                                                break;
                                            }

                                            // console.log(dPC.contenido);
                                            fObtenerEstadoProcesando?.(false);
                                            _f_.asignar(ev_u, {
                                              procesandoApi: false,
                                            });
                                            _f_.asignar(ev_u, {
                                              do_registroEvento: {},
                                            });
                                            
                                          // }
                                        });
                                      // }
                                      break;
                                  }
                                },
                              }),
                            };
                            if (etiqueta) {
                              etiquetas.push([etiqueta, atributos]);
                            }
                            //etiquetas.push([etiqueta, atributos]);
                          } else if (permiteOpciones && celemento.tipo == "control") {
                            let opciones = rrelemento?.[celemento?.valor] ?? opcionesPorDefecto;
                            let funcionEvento = celemento?.funcionEvento;
                            const atributos = {
                              tipo: "btn-2",
                              estilos: {
                                color: "var(--color_transparente)",
                                anchoB2: "2.6rem",
                                alto: "2.6rem",
                              },
                            };

                            const fRegistroOpcion = ([tipoOpcion, parametrosParaFuncionDinamica, modo]) => {
                              // console.log("hice click", tipoOpcion);
                              if (modo != "AGREGARCATEGORIA") {
                                _f_.asignar(ev_u, {
                                  v_modal: true,
                                  do_registroEvento: registrosFiltrados[i].registros[k],
                                  do_estilosModal: celemento?.funcionEvento?.[tipoOpcion].estilos,
                                  d_registroEventoComponente: celemento?.funcionEvento?.[tipoOpcion].componente,
                                  d_registroEventoTipo: tipoOpcion,
                                  do_registroEventoParametros: parametrosParaFuncionDinamica,
                                  d_registroEventoEndpoint: celemento?.funcionEvento?.[tipoOpcion]?.endpoint,
                                  d_registroEventoTimeout: celemento?.funcionEvento?.[tipoOpcion]?.timeout,
                                  d_registroEventoTitulo: celemento?.funcionEvento?.[tipoOpcion]?.titulo,
                                });
                              } else {
                                return {
                                  registroEvento: registrosFiltrados[i].registros[k],
                                  titulo: celemento?.funcionEvento?.[tipoOpcion]?.titulo,
                                };
                              }
                            };

                            componentesOpciones({
                              etiquetas,
                              opciones,
                              atributos,
                              celemento,
                              rrelemento,
                              relemento,
                              fRegistroOpcion,
                              funcionEvento,
                              modo: "COMPONENTE",
                            });
                          }
                          return (
                            <span key={j} className={`Tabla-a-c-elemento ${celemento.visible ? "" : v_u.ec_oculto}`}>
                              {etiquetas.map(([Etiqueta, atributos], l) => {
                                return <Etiqueta {...atributos} key={l} />;
                              })}
                            </span>
                          );
                        })}
                      </div>
                      {permiteDespliegueInferiorPorRegistro && (
                        <div
                          style={_f_.estilosObjetoVariablesCSS(v_u.eo_estilos)}
                          className={`Tabla-a-registro detalleInferior ${
                            "Tabla-rrelemento-" +
                              _f_.concatenarValoresConArreglo({
                                prefijo: relemento?.[campoCodigoDespliegaDetalleRegistro] ?? "",
                                arregloClaves: camposCodigosSeleccion,
                                objeto: registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k],
                                union: "-",
                              }) in
                            v_u.do_desplegableSeleccionados
                              ? "expandido"
                              : ""
                          }`}
                          onClick={(evento) => {
                            // evento.target.classList.toggle("girado");
                          }}>
                          {"Tabla-rrelemento-" +
                            _f_.concatenarValoresConArreglo({
                              prefijo: relemento?.[campoCodigoDespliegaDetalleRegistro] ?? "",
                              arregloClaves: camposCodigosSeleccion,
                              objeto: registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k],
                              union: "-",
                            }) in
                            v_u.do_desplegableSeleccionados &&
                            Array.from({ length: 1 }).map((el, indexDetalle) => {
                              const ComponenteDetalleInferior =
                                mapaDeComponentes?.[v_u.d_registroEventoComponenteInferior];
                              // console.log("mapaDeComponentes",mapaDeComponentes)
                              // console.log("v_u.d_registroEventoComponente",v_u.d_registroEventoComponente)
                              // console.log("v_u.d_registroEventoComponenteInferior",v_u.d_registroEventoComponenteInferior)
                              // console.log("ComponenteDetalleInferior",ComponenteDetalleInferior)
                              // console.log(registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k]);

                              const parametrosDetalleInferior = {
                                origenComponente: origenComponente,
                                registro: registrosFiltrados[i]?.[campoCodigoRegistrosPorCategoria][k], //v_u.do_registroEvento,
                                parametros: v_u.do_registroEventoParametros,
                                tipoEvento: v_u.d_registroEventoTipo,
                                fCerrarComponente: () => {},
                                fEstablecerVariablesTabla: ev_u,
                                fActualizarTablaTotal: fNotificarActualizacionDeTabla,
                              };
                              return (
                                <div key={indexDetalle} className={"Tabla-a-contenido-detalleInferior"}>
                                  {v_u.d_registroEventoComponenteInferior && (
                                    <ComponenteDetalleInferior {...parametrosDetalleInferior} />
                                  )}
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            {relemento?.[campoOpcionesTablaInterna] && (
              <div className={"Tabla-a-opciones"}>
                {relemento?.[campoOpcionesTablaInterna]?.map((arregloOpciones, i) => {
                  return (
                    <div key={i} className={"Tabla-a-opciones-registro"}>
                      {arregloOpciones?.map((opcion, j) => {
                        let Etiqueta2 = elementos[opcion?.tipo];
                        let valor = _f_.formatearValor({
                          valor: relemento?.[opcion?.valor],
                          ...opcion?.formato,
                        });
                        let parametroComplemento = {};
                        switch (opcion?.tipo) {
                          case "textarea":
                            parametroComplemento = {
                              defaultValue:
                                v_d?.[relemento?.[campoCodigoCategoria] + "-" + (opcion?.variable ?? opcion?.valor)],
                            }; //{ defaultValue: valor };
                            break;
                          case "div":
                            if (![undefined, null, ""].includes(valor))
                              parametroComplemento = {
                                texto:
                                  v_d?.[relemento?.[campoCodigoCategoria] + "-" + (opcion?.variable ?? opcion?.valor)],
                              }; //{ texto: valor };
                            break;
                          // default:
                          //   parametroComplemento = {texto: valor};
                        }
                        let parametros = {
                          tipo: "btn-2",
                          ...(opcion?.props ?? {}),
                          ...parametroComplemento,
                          ...(opcion?.funcionEvento?.tipo && {
                            [opcion?.funcionEvento?.tipo]: (evento) => {
                              let parametrosParaFuncionDinamica = {
                                ...opcion?.funcionEvento?.parametros,
                              };
                              for (let [parametroFuncion, campoRegistro] of Object.entries(
                                opcion?.funcionEvento?.parametros,
                              )) {
                                //console.log(parametroFuncion, campoRegistro);
                                switch (campoRegistro.tipo) {
                                  case "constante":
                                    parametrosParaFuncionDinamica[parametroFuncion] = campoRegistro?.["clave"];
                                    break;
                                  case "evento":
                                    parametrosParaFuncionDinamica[parametroFuncion] = evento.target.value;
                                    break;
                                  case "registro":
                                    parametrosParaFuncionDinamica[parametroFuncion] = relemento?.[campoRegistro?.clave];
                                    break;
                                  case "categoria":
                                    parametrosParaFuncionDinamica[parametroFuncion] = relemento?.[campoRegistro?.clave];
                                    break;
                                  case "complemento":
                                    parametrosParaFuncionDinamica[parametroFuncion] =
                                      datosComplementarios[campoRegistro?.clave];
                                    break;
                                }
                              }
                              switch (opcion?.funcionEvento?.modo) {
                                case "MODAL":
                                  _f_.asignar(ev_u, {
                                    v_modal: true,
                                    do_registroEvento: relemento,
                                    d_registroEventoComponente: opcion?.funcionEvento?.componente,
                                    d_registroEventoTipo: evento.type,
                                    do_registroEventoParametros: parametrosParaFuncionDinamica,
                                    d_registroEventoEndpoint: opcion?.funcionEvento?.endpoint,
                                    d_registroEventoTimeout: opcion?.funcionEvento?.timeout,
                                    d_registroEventoTitulo: opcion?.funcionEvento?.titulo,
                                  });
                                  break;
                                case "API":
                                  if (evento.target.value != "" && evento.target.value != valor) {
                                    //ADAPTAR PARAMETROS PARA LEER DEL REGISTRO

                                    let llamadoDinamicoApi = _api_.f_llamarApiDinamica({
                                      parametros: parametrosParaFuncionDinamica,
                                      endpoint: opcion?.funcionEvento?.endpoint,
                                      timeout: opcion?.funcionEvento?.timeout,
                                    });
                                    llamadoDinamicoApi?.respuesta.then((dPC) => {
                                      //ecv_u(dPC);
                                      _f_.asignar(ecv_u, dPC, true, origenComponente);
                                      if (!dPC.error) {
                                        fNotificarActualizacionDeTabla?.(true);
                                        console.log(dPC.contenido);
                                      }
                                    });
                                  }
                                  break;
                              }
                            },
                          }),
                        };
                        //console.log(parametros)
                        return (
                          <div
                            key={j}
                            className={"Tabla-a-opciones-elemento"}
                            style={_f_.estilosObjetoVariablesCSS(opcion?.estilos)}>
                            <Etiqueta2 {...parametros} />
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}
            {/*fin tabla categoria*/}
          </div>
        );
      })}
      {Array.from({ length: 0 }).map((_, l) => {
        return <>{}</>;
      })}
    </div>
  );
};
